import PropTypes from 'prop-types'
import classNames from 'classnames'
import { get } from 'lodash'

import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player'

import RawHTML from '../../../common/raw-html'
import { KIND_AUDIO } from '../constants'

const Player = ({ resource, ...attrs }) => {
  const hasEmbedCode = !!resource.embedCode
  const hasFile = !!get(resource, 'multimedia.file', null)

  let match = null
  let padding = '56.25%'

  if (hasEmbedCode) {
    match = resource.embedCode.match(/height="(\d+)(.*)"/)
    if (match) {
      const value = match[1]
      const unit = match[2]
      if (unit === 'px' || unit === '') {
        padding = `${value}px`
      }
    }
  }

  attrs.className = classNames(
    attrs.className,
    [
      hasEmbedCode ? 'h-0' : '',
      'w-full',
      'relative',
      'bg-black-01',
      'iframe-wrapper'
    ]
  )

  attrs.style = {
    ...attrs.style ? attrs.style : {},
    paddingTop: hasEmbedCode ? padding : null
  }

  return <>
    {
      resource.kind === KIND_AUDIO
        ? hasEmbedCode
          ? <div
            {...attrs}>
            <RawHTML html={resource.embedCode} />
          </div>
          : hasFile
            ? <div
              {...attrs}>
              <AudioPlayer
                className={'simple-audio-player'}
                layout="horizontal-reverse"
                src={resource.multimedia.file}
                showJumpControls={false}
                customAdditionalControls={[]}
                customVolumeControls={[]}
                customProgressBarSection={
                  [
                    RHAP_UI.CURRENT_TIME,
                    RHAP_UI.PROGRESS_BAR,
                    RHAP_UI.DURATION
                  ]
                } />
            </div>
            : null
        : null
    }
  </>
}

Player.propTypes = {
  resource: PropTypes.object.isRequired
}

export default Player
